import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class SelectWrapper extends React.Component {
  handleChange = event => {
    this.props.onChange(this.props.input, event.target.value);
  }

  onBlur = () => {
    if (this.props.onBlur) this.props.onBlur();
  }

  render() {
    let errors = this.props.input.validations.errors.map(e => e);
    const selectClass = classNames({
      'form-control': true,
      'disabled': this.props.editing === false,
      'error': this.props.input.validations.errors.length > 0
    });

    return <div onBlur={this.onBlur} style={this.props.style.wrapper}>
      <select
        style={this.props.style.select}
        className={this.props.inputClass || selectClass}
        value={this.props.input.validations.val}
        onBlur={() => this.props.valid(this.props.input)}
        onChange={this.handleChange}
        tabIndex={this.props.tabOrder}
        disabled={!this.props.editing}>
        {this.props.list.map((l, i) => <option style={this.props.style.option} key={i} value={l.value}>{l.label}</option>)}
      </select>

      {errors.length > 0 && <ul>
        {errors.map((e, i) => e.message !== '' && <li key={i} className="error">
          {e.message}
        </li>)}
      </ul>}
    </div>;
  }
}

SelectWrapper.defaultProps = {
  style: {
    wrapper: null,
    select: null,
    option: null
  }
}

SelectWrapper.PropTypes = {
  list: PropTypes.array.isRequired,
  input: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  valid: PropTypes.func,
  validations: PropTypes.func,
  tabOrder: PropTypes.string,
  editing: PropTypes.bool,
  style: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Wrappers/SelectWrapper.js